export const Assets = {
    "IMG_BARREL": {
        "type": "IMAGE",
        "key": "IMG_BARREL",
        "imageUrl": "assets/images/barrel.png"
    },
    "IMG_BASE": {
        "type": "IMAGE",
        "key": "IMG_BASE",
        "imageUrl": "assets/images/base.png"
    },
    "IMG_BG_BASE": {
        "type": "IMAGE",
        "key": "IMG_BG_BASE",
        "imageUrl": "assets/images/bg_base.png"
    },
    "IMG_BOX1": {
        "type": "IMAGE",
        "key": "IMG_BOX1",
        "imageUrl": "assets/images/box1.png"
    },
    "IMG_BOX2": {
        "type": "IMAGE",
        "key": "IMG_BOX2",
        "imageUrl": "assets/images/box2.png"
    },
    "IMG_BOX3": {
        "type": "IMAGE",
        "key": "IMG_BOX3",
        "imageUrl": "assets/images/box3.png"
    },
    "IMG_BOX4": {
        "type": "IMAGE",
        "key": "IMG_BOX4",
        "imageUrl": "assets/images/box4.png"
    },
    "IMG_BOX5": {
        "type": "IMAGE",
        "key": "IMG_BOX5",
        "imageUrl": "assets/images/box5.png"
    },
    "IMG_BTN_HELP": {
        "type": "IMAGE",
        "key": "IMG_BTN_HELP",
        "imageUrl": "assets/images/btn_help.png"
    },
    "IMG_BTN_HOME": {
        "type": "IMAGE",
        "key": "IMG_BTN_HOME",
        "imageUrl": "assets/images/btn_home.png"
    },
    "IMG_BTN_OK": {
        "type": "IMAGE",
        "key": "IMG_BTN_OK",
        "imageUrl": "assets/images/btn_ok.png"
    },
    "IMG_BTN_SOUND_OFF": {
        "type": "IMAGE",
        "key": "IMG_BTN_SOUND_OFF",
        "imageUrl": "assets/images/btn_sound_off.png"
    },
    "IMG_BTN_SOUND_ON": {
        "type": "IMAGE",
        "key": "IMG_BTN_SOUND_ON",
        "imageUrl": "assets/images/btn_sound_on.png"
    },
    "IMG_BUILDING1": {
        "type": "IMAGE",
        "key": "IMG_BUILDING1",
        "imageUrl": "assets/images/building1.png"
    },
    "IMG_BUILDING10": {
        "type": "IMAGE",
        "key": "IMG_BUILDING10",
        "imageUrl": "assets/images/building10.png"
    },
    "IMG_BUILDING11": {
        "type": "IMAGE",
        "key": "IMG_BUILDING11",
        "imageUrl": "assets/images/building11.png"
    },
    "IMG_BUILDING12": {
        "type": "IMAGE",
        "key": "IMG_BUILDING12",
        "imageUrl": "assets/images/building12.png"
    },
    "IMG_BUILDING13": {
        "type": "IMAGE",
        "key": "IMG_BUILDING13",
        "imageUrl": "assets/images/building13.png"
    },
    "IMG_BUILDING2": {
        "type": "IMAGE",
        "key": "IMG_BUILDING2",
        "imageUrl": "assets/images/building2.png"
    },
    "IMG_BUILDING3": {
        "type": "IMAGE",
        "key": "IMG_BUILDING3",
        "imageUrl": "assets/images/building3.png"
    },
    "IMG_BUILDING4": {
        "type": "IMAGE",
        "key": "IMG_BUILDING4",
        "imageUrl": "assets/images/building4.png"
    },
    "IMG_BUILDING5": {
        "type": "IMAGE",
        "key": "IMG_BUILDING5",
        "imageUrl": "assets/images/building5.png"
    },
    "IMG_BUILDING6": {
        "type": "IMAGE",
        "key": "IMG_BUILDING6",
        "imageUrl": "assets/images/building6.png"
    },
    "IMG_BUILDING7": {
        "type": "IMAGE",
        "key": "IMG_BUILDING7",
        "imageUrl": "assets/images/building7.png"
    },
    "IMG_BUILDING8": {
        "type": "IMAGE",
        "key": "IMG_BUILDING8",
        "imageUrl": "assets/images/building8.png"
    },
    "IMG_BUILDING9": {
        "type": "IMAGE",
        "key": "IMG_BUILDING9",
        "imageUrl": "assets/images/building9.png"
    },
    "IMG_CLOCKICON": {
        "type": "IMAGE",
        "key": "IMG_CLOCKICON",
        "imageUrl": "assets/images/clockicon.png"
    },
    "IMG_CRATE1": {
        "type": "IMAGE",
        "key": "IMG_CRATE1",
        "imageUrl": "assets/images/crate1.png"
    },
    "IMG_CRATE1SHADOW": {
        "type": "IMAGE",
        "key": "IMG_CRATE1SHADOW",
        "imageUrl": "assets/images/crate1shadow.png"
    },
    "IMG_CRATE2": {
        "type": "IMAGE",
        "key": "IMG_CRATE2",
        "imageUrl": "assets/images/crate2.png"
    },
    "IMG_CROSSHAIR_HUD": {
        "type": "IMAGE",
        "key": "IMG_CROSSHAIR_HUD",
        "imageUrl": "assets/images/crosshair_hud.png"
    },
    "IMG_CROSSHAIR": {
        "type": "IMAGE",
        "key": "IMG_CROSSHAIR",
        "imageUrl": "assets/images/crosshair.png"
    },
    "IMG_DOUBLEWALL": {
        "type": "IMAGE",
        "key": "IMG_DOUBLEWALL",
        "imageUrl": "assets/images/doublewall.png"
    },
    "IMG_DOUBLEWALL1": {
        "type": "IMAGE",
        "key": "IMG_DOUBLEWALL1",
        "imageUrl": "assets/images/doublewall1.png"
    },
    "IMG_DOUBLEWALLNEW": {
        "type": "IMAGE",
        "key": "IMG_DOUBLEWALLNEW",
        "imageUrl": "assets/images/doublewallnew.png"
    },
    "IMG_ENEMIES_HELP_ICON": {
        "type": "IMAGE",
        "key": "IMG_ENEMIES_HELP_ICON",
        "imageUrl": "assets/images/enemies_help_icon.png"
    },
    "IMG_FENCE_AT_BACK": {
        "type": "IMAGE",
        "key": "IMG_FENCE_AT_BACK",
        "imageUrl": "assets/images/fence_at_back.png"
    },
    "IMG_GAMEOVER_0001": {
        "type": "IMAGE",
        "key": "IMG_GAMEOVER_0001",
        "imageUrl": "assets/images/gameover_0001.png"
    },
    "IMG_GAMEOVER_0002": {
        "type": "IMAGE",
        "key": "IMG_GAMEOVER_0002",
        "imageUrl": "assets/images/gameover_0002.png"
    },
    "IMG_GAMEOVER_0003": {
        "type": "IMAGE",
        "key": "IMG_GAMEOVER_0003",
        "imageUrl": "assets/images/gameover_0003.png"
    },
    "IMG_GAMEOVER_0004": {
        "type": "IMAGE",
        "key": "IMG_GAMEOVER_0004",
        "imageUrl": "assets/images/gameover_0004.png"
    },
    "IMG_GAMEOVER_0005": {
        "type": "IMAGE",
        "key": "IMG_GAMEOVER_0005",
        "imageUrl": "assets/images/gameover_0005.png"
    },
    "IMG_GAMEOVER_0006": {
        "type": "IMAGE",
        "key": "IMG_GAMEOVER_0006",
        "imageUrl": "assets/images/gameover_0006.png"
    },
    "IMG_GATE1": {
        "type": "IMAGE",
        "key": "IMG_GATE1",
        "imageUrl": "assets/images/gate1.png"
    },
    "IMG_GUN_RELOAD_0001": {
        "type": "IMAGE",
        "key": "IMG_GUN_RELOAD_0001",
        "imageUrl": "assets/images/gun_reload_0001.png"
    },
    "IMG_GUN_RELOAD_0002": {
        "type": "IMAGE",
        "key": "IMG_GUN_RELOAD_0002",
        "imageUrl": "assets/images/gun_reload_0002.png"
    },
    "IMG_GUN_RELOAD_0003": {
        "type": "IMAGE",
        "key": "IMG_GUN_RELOAD_0003",
        "imageUrl": "assets/images/gun_reload_0003.png"
    },
    "IMG_GUN_RELOAD_0004": {
        "type": "IMAGE",
        "key": "IMG_GUN_RELOAD_0004",
        "imageUrl": "assets/images/gun_reload_0004.png"
    },
    "IMG_GUN_RELOAD_0005": {
        "type": "IMAGE",
        "key": "IMG_GUN_RELOAD_0005",
        "imageUrl": "assets/images/gun_reload_0005.png"
    },
    "IMG_GUN_RELOAD_0006": {
        "type": "IMAGE",
        "key": "IMG_GUN_RELOAD_0006",
        "imageUrl": "assets/images/gun_reload_0006.png"
    },
    "IMG_GUN_RELOAD_0007": {
        "type": "IMAGE",
        "key": "IMG_GUN_RELOAD_0007",
        "imageUrl": "assets/images/gun_reload_0007.png"
    },
    "IMG_GUN_RELOAD_0008": {
        "type": "IMAGE",
        "key": "IMG_GUN_RELOAD_0008",
        "imageUrl": "assets/images/gun_reload_0008.png"
    },
    "IMG_GUN_RELOAD_0009": {
        "type": "IMAGE",
        "key": "IMG_GUN_RELOAD_0009",
        "imageUrl": "assets/images/gun_reload_0009.png"
    },
    "IMG_GUN_RELOAD_0010": {
        "type": "IMAGE",
        "key": "IMG_GUN_RELOAD_0010",
        "imageUrl": "assets/images/gun_reload_0010.png"
    },
    "IMG_GUN_RELOAD_0011": {
        "type": "IMAGE",
        "key": "IMG_GUN_RELOAD_0011",
        "imageUrl": "assets/images/gun_reload_0011.png"
    },
    "IMG_GUN_RELOAD_0012": {
        "type": "IMAGE",
        "key": "IMG_GUN_RELOAD_0012",
        "imageUrl": "assets/images/gun_reload_0012.png"
    },
    "IMG_GUN_RELOAD_0013": {
        "type": "IMAGE",
        "key": "IMG_GUN_RELOAD_0013",
        "imageUrl": "assets/images/gun_reload_0013.png"
    },
    "IMG_GUN_RELOAD_0014": {
        "type": "IMAGE",
        "key": "IMG_GUN_RELOAD_0014",
        "imageUrl": "assets/images/gun_reload_0014.png"
    },
    "IMG_MENU_BG": {
        "type": "IMAGE",
        "key": "IMG_MENU_BG",
        "imageUrl": "assets/images/menu_bg.png"
    },
    "IMG_MENU_PLANTS": {
        "type": "IMAGE",
        "key": "IMG_MENU_PLANTS",
        "imageUrl": "assets/images/menu_plants.png"
    },
    "IMG_MENU_SNIPER": {
        "type": "IMAGE",
        "key": "IMG_MENU_SNIPER",
        "imageUrl": "assets/images/menu_sniper.png"
    },
    "IMG_MENU_TITLE": {
        "type": "IMAGE",
        "key": "IMG_MENU_TITLE",
        "imageUrl": "assets/images/menu_title.png"
    },
    "IMG_MISSION_COMPLETED": {
        "type": "IMAGE",
        "key": "IMG_MISSION_COMPLETED",
        "imageUrl": "assets/images/mission_completed.png"
    },
    "IMG_PILLAR_TOWER_FRONT1": {
        "type": "IMAGE",
        "key": "IMG_PILLAR_TOWER_FRONT1",
        "imageUrl": "assets/images/pillar_tower_front1.png"
    },
    "IMG_PILLAR_TOWER_FRONT2": {
        "type": "IMAGE",
        "key": "IMG_PILLAR_TOWER_FRONT2",
        "imageUrl": "assets/images/pillar_tower_front2.png"
    },
    "IMG_PLANT_LEFT": {
        "type": "IMAGE",
        "key": "IMG_PLANT_LEFT",
        "imageUrl": "assets/images/plant_left.png"
    },
    "IMG_PLANT_RIGHT": {
        "type": "IMAGE",
        "key": "IMG_PLANT_RIGHT",
        "imageUrl": "assets/images/plant_right.png"
    },
    "IMG_PLANT_SET1": {
        "type": "IMAGE",
        "key": "IMG_PLANT_SET1",
        "imageUrl": "assets/images/plant_set1.png"
    },
    "IMG_PLANT_SET2": {
        "type": "IMAGE",
        "key": "IMG_PLANT_SET2",
        "imageUrl": "assets/images/plant_set2.png"
    },
    "IMG_PLANT_SET3": {
        "type": "IMAGE",
        "key": "IMG_PLANT_SET3",
        "imageUrl": "assets/images/plant_set3.png"
    },
    "IMG_PLANT1": {
        "type": "IMAGE",
        "key": "IMG_PLANT1",
        "imageUrl": "assets/images/plant1.png"
    },
    "IMG_PLANT2": {
        "type": "IMAGE",
        "key": "IMG_PLANT2",
        "imageUrl": "assets/images/plant2.png"
    },
    "IMG_PLANT3": {
        "type": "IMAGE",
        "key": "IMG_PLANT3",
        "imageUrl": "assets/images/plant3.png"
    },
    "IMG_PLANT4": {
        "type": "IMAGE",
        "key": "IMG_PLANT4",
        "imageUrl": "assets/images/plant4.png"
    },
    "IMG_PLANT5": {
        "type": "IMAGE",
        "key": "IMG_PLANT5",
        "imageUrl": "assets/images/plant5.png"
    },
    "IMG_PLANT6": {
        "type": "IMAGE",
        "key": "IMG_PLANT6",
        "imageUrl": "assets/images/plant6.png"
    },
    "IMG_POPUP_BOX_NEW": {
        "type": "IMAGE",
        "key": "IMG_POPUP_BOX_NEW",
        "imageUrl": "assets/images/popup_box_new.png"
    },
    "IMG_POPUP_INNER_BOX": {
        "type": "IMAGE",
        "key": "IMG_POPUP_INNER_BOX",
        "imageUrl": "assets/images/popup_inner_box.png"
    },
    "IMG_SHADOW1": {
        "type": "IMAGE",
        "key": "IMG_SHADOW1",
        "imageUrl": "assets/images/shadow1.png"
    },
    "IMG_SHADOW2": {
        "type": "IMAGE",
        "key": "IMG_SHADOW2",
        "imageUrl": "assets/images/shadow2.png"
    },
    "IMG_SHADOWPIECE": {
        "type": "IMAGE",
        "key": "IMG_SHADOWPIECE",
        "imageUrl": "assets/images/shadowpiece.png"
    },
    "IMG_SINGLEWALL": {
        "type": "IMAGE",
        "key": "IMG_SINGLEWALL",
        "imageUrl": "assets/images/singlewall.png"
    },
    "IMG_SINGLEWALL1": {
        "type": "IMAGE",
        "key": "IMG_SINGLEWALL1",
        "imageUrl": "assets/images/singlewall1.png"
    },
    "IMG_SNIPE": {
        "type": "IMAGE",
        "key": "IMG_SNIPE",
        "imageUrl": "assets/images/snipe.png"
    },
    "IMG_TERRORIST": {
        "type": "IMAGE",
        "key": "IMG_TERRORIST",
        "imageUrl": "assets/images/terrorist.png"
    },
    "IMG_TREE1": {
        "type": "IMAGE",
        "key": "IMG_TREE1",
        "imageUrl": "assets/images/tree1.png"
    },
    "IMG_TREE2": {
        "type": "IMAGE",
        "key": "IMG_TREE2",
        "imageUrl": "assets/images/tree2.png"
    },
    "IMG_TREE3": {
        "type": "IMAGE",
        "key": "IMG_TREE3",
        "imageUrl": "assets/images/tree3.png"
    },
    "IMG_TREE4": {
        "type": "IMAGE",
        "key": "IMG_TREE4",
        "imageUrl": "assets/images/tree4.png"
    },
    "IMG_TRIPLEWALL": {
        "type": "IMAGE",
        "key": "IMG_TRIPLEWALL",
        "imageUrl": "assets/images/triplewall.png"
    },
    "IMG_UPGRADE_TIME_ADS": {
        "type": "IMAGE",
        "key": "IMG_UPGRADE_TIME_ADS",
        "imageUrl": "assets/images/upgrade_time_ads.png"
    },
    "IMG_UPGRADE_TIME_POINTS": {
        "type": "IMAGE",
        "key": "IMG_UPGRADE_TIME_POINTS",
        "imageUrl": "assets/images/upgrade_time_points.png"
    },
    "IMG_UPGRADE_ZOOM_ADS": {
        "type": "IMAGE",
        "key": "IMG_UPGRADE_ZOOM_ADS",
        "imageUrl": "assets/images/upgrade_zoom_ads.png"
    },
    "IMG_UPGRADE_ZOOM_POINTS": {
        "type": "IMAGE",
        "key": "IMG_UPGRADE_ZOOM_POINTS",
        "imageUrl": "assets/images/upgrade_zoom_points.png"
    },
    "IMG_WALL_TOWER_BACK": {
        "type": "IMAGE",
        "key": "IMG_WALL_TOWER_BACK",
        "imageUrl": "assets/images/wall_tower_back.png"
    },
    "IMG_WALL_TOWER_FRONT": {
        "type": "IMAGE",
        "key": "IMG_WALL_TOWER_FRONT",
        "imageUrl": "assets/images/wall_tower_front.png"
    },
    "IMG_WALL_TOWER_FRONT1": {
        "type": "IMAGE",
        "key": "IMG_WALL_TOWER_FRONT1",
        "imageUrl": "assets/images/wall_tower_front1.png"
    },
    "IMG_WALL": {
        "type": "IMAGE",
        "key": "IMG_WALL",
        "imageUrl": "assets/images/wall.png"
    },
    "IMG_WALL2": {
        "type": "IMAGE",
        "key": "IMG_WALL2",
        "imageUrl": "assets/images/wall2.png"
    },
    "ATLAS_HIT_ON_WOOD": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_HIT_ON_WOOD",
        "imageUrl": "assets/images/hit_on_wood.png",
        "jsonUrl": "assets/images/hit_on_wood.json"
    },
    "ATLAS_TERROR_ALERT": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_TERROR_ALERT",
        "imageUrl": "assets/images/terror_alert.png",
        "jsonUrl": "assets/images/terror_alert.json"
    },
    "ATLAS_TERROR_ALERT1": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_TERROR_ALERT1",
        "imageUrl": "assets/images/terror_alert1.png",
        "jsonUrl": "assets/images/terror_alert1.json"
    },
    "ATLAS_TERROR_IDLE": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_TERROR_IDLE",
        "imageUrl": "assets/images/terror_idle.png",
        "jsonUrl": "assets/images/terror_idle.json"
    },
    "ATLAS_TERROR_IDLE1": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_TERROR_IDLE1",
        "imageUrl": "assets/images/terror_idle1.png",
        "jsonUrl": "assets/images/terror_idle1.json"
    },
    "ATLAS_TERROR_KILLED": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_TERROR_KILLED",
        "imageUrl": "assets/images/terror_killed.png",
        "jsonUrl": "assets/images/terror_killed.json"
    },
    "ATLAS_TERROR_KILLED1": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_TERROR_KILLED1",
        "imageUrl": "assets/images/terror_killed1.png",
        "jsonUrl": "assets/images/terror_killed1.json"
    },
    "ATLAS_TERROR_SHOOT": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_TERROR_SHOOT",
        "imageUrl": "assets/images/terror_shoot.png",
        "jsonUrl": "assets/images/terror_shoot.json"
    },
    "ATLAS_TERROR_SHOOT1": {
        "type": "ATLAS_JSON",
        "key": "ATLAS_TERROR_SHOOT1",
        "imageUrl": "assets/images/terror_shoot1.png",
        "jsonUrl": "assets/images/terror_shoot1.json"
    },
    "FRAME_HIT_ON_WOOD_HIT_ON_WOOD_0001": "hit_on_wood_0001",
    "FRAME_HIT_ON_WOOD_HIT_ON_WOOD_0002": "hit_on_wood_0002",
    "FRAME_HIT_ON_WOOD_HIT_ON_WOOD_0003": "hit_on_wood_0003",
    "FRAME_HIT_ON_WOOD_HIT_ON_WOOD_0004": "hit_on_wood_0004",
    "FRAME_TERROR_ALERT_TERROR_ALERT_0001": "terror_alert_0001",
    "FRAME_TERROR_ALERT_TERROR_ALERT_0002": "terror_alert_0002",
    "FRAME_TERROR_ALERT_TERROR_ALERT_0003": "terror_alert_0003",
    "FRAME_TERROR_ALERT_TERROR_ALERT_0004": "terror_alert_0004",
    "FRAME_TERROR_ALERT_TERROR_ALERT_0006": "terror_alert_0006",
    "FRAME_TERROR_ALERT_TERROR_ALERT_0005": "terror_alert_0005",
    "FRAME_TERROR_ALERT1_TERROR_ALERT1_0001": "terror_alert1_0001",
    "FRAME_TERROR_ALERT1_TERROR_ALERT1_0004": "terror_alert1_0004",
    "FRAME_TERROR_ALERT1_TERROR_ALERT1_0002": "terror_alert1_0002",
    "FRAME_TERROR_ALERT1_TERROR_ALERT1_0003": "terror_alert1_0003",
    "FRAME_TERROR_ALERT1_TERROR_ALERT1_0005": "terror_alert1_0005",
    "FRAME_TERROR_ALERT1_TERROR_ALERT1_0006": "terror_alert1_0006",
    "FRAME_TERROR_IDLE_TERROR_IDLE_0001": "terror_idle_0001",
    "FRAME_TERROR_IDLE_TERROR_IDLE_0005": "terror_idle_0005",
    "FRAME_TERROR_IDLE_TERROR_IDLE_0008": "terror_idle_0008",
    "FRAME_TERROR_IDLE_TERROR_IDLE_0002": "terror_idle_0002",
    "FRAME_TERROR_IDLE_TERROR_IDLE_0003": "terror_idle_0003",
    "FRAME_TERROR_IDLE_TERROR_IDLE_0004": "terror_idle_0004",
    "FRAME_TERROR_IDLE_TERROR_IDLE_0006": "terror_idle_0006",
    "FRAME_TERROR_IDLE_TERROR_IDLE_0007": "terror_idle_0007",
    "FRAME_TERROR_IDLE_TERROR_IDLE_0009": "terror_idle_0009",
    "FRAME_TERROR_IDLE_TERROR_IDLE_0010": "terror_idle_0010",
    "FRAME_TERROR_IDLE1_TERROR_IDLE1_0001": "terror_idle1_0001",
    "FRAME_TERROR_IDLE1_TERROR_IDLE1_0002": "terror_idle1_0002",
    "FRAME_TERROR_IDLE1_TERROR_IDLE1_0003": "terror_idle1_0003",
    "FRAME_TERROR_IDLE1_TERROR_IDLE1_0004": "terror_idle1_0004",
    "FRAME_TERROR_IDLE1_TERROR_IDLE1_0005": "terror_idle1_0005",
    "FRAME_TERROR_IDLE1_TERROR_IDLE1_0006": "terror_idle1_0006",
    "FRAME_TERROR_IDLE1_TERROR_IDLE1_0007": "terror_idle1_0007",
    "FRAME_TERROR_IDLE1_TERROR_IDLE1_0008": "terror_idle1_0008",
    "FRAME_TERROR_IDLE1_TERROR_IDLE1_0009": "terror_idle1_0009",
    "FRAME_TERROR_IDLE1_TERROR_IDLE1_0010": "terror_idle1_0010",
    "FRAME_TERROR_KILLED_TERROR_KILLED_0001": "terror_killed_0001",
    "FRAME_TERROR_KILLED_TERROR_KILLED_0002": "terror_killed_0002",
    "FRAME_TERROR_KILLED_TERROR_KILLED_0003": "terror_killed_0003",
    "FRAME_TERROR_KILLED_TERROR_KILLED_0004": "terror_killed_0004",
    "FRAME_TERROR_KILLED_TERROR_KILLED_0005": "terror_killed_0005",
    "FRAME_TERROR_KILLED_TERROR_KILLED_0006": "terror_killed_0006",
    "FRAME_TERROR_KILLED1_TERROR_KILLED1_0001": "terror_killed1_0001",
    "FRAME_TERROR_KILLED1_TERROR_KILLED1_0002": "terror_killed1_0002",
    "FRAME_TERROR_KILLED1_TERROR_KILLED1_0003": "terror_killed1_0003",
    "FRAME_TERROR_KILLED1_TERROR_KILLED1_0004": "terror_killed1_0004",
    "FRAME_TERROR_KILLED1_TERROR_KILLED1_0005": "terror_killed1_0005",
    "FRAME_TERROR_KILLED1_TERROR_KILLED1_0006": "terror_killed1_0006",
    "FRAME_TERROR_SHOOT_TERROR_SHOOT_0001": "terror_shoot_0001",
    "FRAME_TERROR_SHOOT_TERROR_SHOOT_0002": "terror_shoot_0002",
    "FRAME_TERROR_SHOOT_TERROR_SHOOT_0003": "terror_shoot_0003",
    "FRAME_TERROR_SHOOT_TERROR_SHOOT_0005": "terror_shoot_0005",
    "FRAME_TERROR_SHOOT_TERROR_SHOOT_0007": "terror_shoot_0007",
    "FRAME_TERROR_SHOOT_TERROR_SHOOT_0009": "terror_shoot_0009",
    "FRAME_TERROR_SHOOT_TERROR_SHOOT_0004": "terror_shoot_0004",
    "FRAME_TERROR_SHOOT_TERROR_SHOOT_0006": "terror_shoot_0006",
    "FRAME_TERROR_SHOOT_TERROR_SHOOT_0008": "terror_shoot_0008",
    "FRAME_TERROR_SHOOT_TERROR_SHOOT_0010": "terror_shoot_0010",
    "FRAME_TERROR_SHOOT1_TERROR_SHOOT1_0001": "terror_shoot1_0001",
    "FRAME_TERROR_SHOOT1_TERROR_SHOOT1_0002": "terror_shoot1_0002",
    "FRAME_TERROR_SHOOT1_TERROR_SHOOT1_0003": "terror_shoot1_0003",
    "FRAME_TERROR_SHOOT1_TERROR_SHOOT1_0004": "terror_shoot1_0004",
    "FRAME_TERROR_SHOOT1_TERROR_SHOOT1_0005": "terror_shoot1_0005",
    "FRAME_TERROR_SHOOT1_TERROR_SHOOT1_0006": "terror_shoot1_0006",
    "AUDIOSPRITE_SOUNDS": {
        "type": "AUDIOSPRITE",
        "key": "AUDIOSPRITE_SOUNDS",
        "urls": [
            "assets/sounds/sounds.mp3"
        ],
        "jsonUrl": "assets/sounds/sounds.json"
    },
    "AUDIOSPRITE_MARKER_SILENCE": "silence",
    "AUDIOSPRITE_MARKER_BGMUSIC": "bgmusic",
    "AUDIOSPRITE_MARKER_DIE": "die",
    "AUDIOSPRITE_MARKER_RELOAD": "reload",
    "AUDIOSPRITE_MARKER_SHOOT": "shoot",
    "AUDIOSPRITE_MARKER_SIREN": "siren",
    "AUDIOSPRITE_MARKER_SNIPE": "snipe"
}